import { useNotifications, usePushSubscription } from '@ordo/notifications-client/react'
import { NotificationCenter, type NotificationTab } from '@ordo/ui/notification-center'
import { notificationCenterPropsFrom, pushControlFrom } from '@ordo/ui/notification-inbox'
import { useState } from 'react'
import { useNavigate } from 'react-router'

/** The unified inbox bell, read through Comms' own `/api/notifications` proxy. */
export function NotificationBell({ triggerClassName }: { triggerClassName?: string } = {}) {
  const navigate = useNavigate()
  const [tab, setTab] = useState<NotificationTab>('all')
  const inbox = useNotifications({ tab })
  const push = usePushSubscription()
  return (
    <NotificationCenter
      {...notificationCenterPropsFrom(inbox)}
      pushControl={pushControlFrom(push)}
      tab={tab}
      onTabChange={setTab}
      onSeeAll={() => navigate('/notifications')}
      triggerClassName={triggerClassName}
    />
  )
}
